import styled, { css } from 'styled-components';
import spacing from '../../styles/spacing';

export const StyledPhoneInputWrapper = styled.div<{
    $width?: string | number;
    $disabled?: boolean;
}>`
    display: inline-flex;
    align-items: center;
    gap: ${spacing[8]};
    width: ${({ $width }) =>
        $width
            ? typeof $width === 'number'
                ? `${$width}px`
                : $width
            : '100%'};

    ${({ $disabled }) =>
        $disabled &&
        css`
            cursor: not-allowed;
            opacity: 0.6;
        `}
`;

export const StyledCountrySelector = styled.div`
    flex-shrink: 0;
    display: flex;
`;

export const StyledNumberInputWrapper = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;

    && input {
        border-width: 0;
    }
`;
